import { Injectable } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreNavigationBarService } from './point-store-navigation-bar.service';
import { PointStoreProductEditService } from './point-store-product-edit.service';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { PointStoreProductSaveValidation } from 'src/app/gamification/cv-marketplace-admin/models/point-store-product-validation.model';

@Injectable({
  providedIn: 'root'
})
export class PointStoreProductValidationService {

  pointStoreProductValidationMessages: any = [
    { value: 0, name: "Yes", keyLocalization: "Yes" },
    { value: 1, name: "No", keyLocalization: "No" },
    { value: 2, name: "Are you sure you want to delete the Product? All current setting will be lost. Continue anyway?", keyLocalization: "Validate_Delete_Product" },
    { value: 3, name: "Are you sure you want to cancel? All current setting will be lost. Continue anyway?", keyLocalization: "Validate_Cancel_Product" },
    { value: 4, name: "MarketPlace Product Data Validation Warning", keyLocalization: "Order_Management_Validation_Warning" },
    { value: 5, name: "MarketPlace Product Validation Error", keyLocalization: "Product_Management_Validation_Error" },
    { value: 6, name: "Are you sure you want to remove the products selected? Continue anyway?", keyLocalization: "Validate_Remove_Product" },
    { value: 7, name: "Are you sure you want to edit the products selected? Continue anyway?", keyLocalization: "Validate_Edit_Product" },
    { value: 8, name: "Are you sure you want to create a Product without assigning a group? Continue anyway?", keyLocalization: "Validate_Assigning_Product" },
    { value: 9, name: "There is an unknown error. We didn’t see this one coming. Continue anyway?", keyLocalization: "Validate_Unknow_Error" },
    { value: 10, name: "Please select a MarketPlace product title.", keyLocalization: "Validate_Title_Product" },
    { value: 11, name: "Please select a point store product category.", keyLocalization: "Validate_Category_Product" },
    { value: 12, name: "Please select a point store product sub-category.", keyLocalization: "Validate_SubCategory_Product" },
    { value: 13, name: "Please select a price for product.", keyLocalization: "Validate_Price_Product" },
    { value: 14, name: "Product price must be greater than 0.", keyLocalization: "Validate_Price_Minimum_Product" },
    { value: 15, name: "Please only use positive whole numbers for the price of the product.", keyLocalization: "Validate_Price_Positive_Product" },
    { value: 16, name: "Please select a start date for the product.", keyLocalization: "Validate_StartDate_Product" },
    { value: 17, name: "Product start date is in the wrong format. Expected: ", keyLocalization: "Validate_DateFormat_Product" },
    { value: 18, name: "Please select a start date for the Carousel display setting.", keyLocalization: "Validate_StartDate_Carousel" },
    { value: 19, name: "Carousel start date is in the wrong format. Expected: ", keyLocalization: "Validate_StartDate_Carousel_Format" },
    { value: 20, name: "Please select a start date for the Featured display setting.", keyLocalization: "Validate_StartDate_Feature" },
    { value: 21, name: "Featured start date is in the wrong format. Expected: ", keyLocalization: "Validate_StartDate_Feature_Format" },
    { value: 22, name: "Please select a start date for the Sale display setting.", keyLocalization: "Validate_StartDate_Sale" },
    { value: 23, name: "Sale start date is in the wrong format. Expected: ", keyLocalization: "Validate_StartDate_Sale_Format" },
    { value: 24, name: "Please select a sale percent for the product.", keyLocalization: "Validate_Sale_Percent" },
    { value: 25, name: "Product sale must not be a negative number.", keyLocalization: "Validate_Sale_Negative" },
    { value: 26, name: "Product sale must not be more than 100% off.", keyLocalization: "Validate_Sale_More_Percent" },
    { value: 27, name: "Are you sure you want to continue without assigning a group?", keyLocalization: "Validate_Assigning_Group" },
    { value: 28, name: "Please select a quantity for product.", keyLocalization: "Validate_Quantity_Product" },
    { value: 29, name: "Please only use positive whole numbers for the quantity of the product.", keyLocalization: "Validate_Quantity_Number_Product" },
    { value: 30, name: "Please select a carousel start date for the product.", keyLocalization: "Validate_StartDate_Carousel_Product" },
    { value: 31, name: "Please select a feature start date for the product.", keyLocalization: "Validate_StartDate_Featured_Product" },
    { value: 32, name: "Please select a sale start date for the product.", keyLocalization: "Validate_StartDate_Sale_Product" },
    { value: 33, name: "Please select a sale for product.", keyLocalization: "Validate_Sale_Product" },
    { value: 34, name: "Product sale must be greater than 0.", keyLocalization: "Validate_Sale_Minimum_Product" },
    { value: 35, name: "Product price needs to be less than or equal to 100.", keyLocalization: "Validate_Sale_Maximum_Product" },
    { value: 36, name: "Please only use positive whole numbers for the sale of the product.", keyLocalization: "Validate_Sale_Positive_Number" },
    { value: 37, name: "Please add a assignment group.", keyLocalization: "Validate_Assigment_Group" },
    { value: 38, name: "Please add an image.", keyLocalization: "Validate_Add_Image" },
    { value: 39, name: "Please select a MarketPlace product variation type name.", keyLocalization: "Validate_Product_Variation_Type" },
    { value: 40, name: "Name for each variation must be different.", keyLocalization: "Validate_Product_Variation_Name" },
    { value: 41, name: "Please select a MarketPlace product variation name.", keyLocalization: "Validate_Product_Variation_Title" },
    { value: 42, name: "Only a few variations have images. If you don't have an image for a specific variation, select a main product image to be displayed on the variation.", keyLocalization: "Validate_Product_Main_Image" },
    { value: 43, name: "The variation type name must contain only letters.", keyLocalization: "Validate_Variation_Name" },
    { value: 44, name: "You have entered an invalid date, your product's start date should be before the end date.", keyLocalization: "Validate_Product_Dates" },
    { value: 45, name: "You have entered an invalid date, the carousel start date should be before the end date.", keyLocalization: "Validate_Carousel_Dates" },
    { value: 46, name: "You have entered an invalid date, the featured product start date should be before the end date.", keyLocalization: "Validate_Featured_Dates" },
    { value: 47, name: "You have entered an invalid date, the sale start date should be before the end date.", keyLocalization: "Validate_Sale_Dates" },
    { value: 48, name: "Product Title: Not supported Characters \ / ! + < > ? # & , %", keyLocalization: "Validate_Pattern_Product_Title" },
    { value: 49, name: "Product Description: Not supported Characters \ / ! + < > ? # & , %", keyLocalization: "Validate_Pattern_Product_Description" },
    { value: 50, name: "Product Category: Not supported Characters \ / ! + < > ? # & , %", keyLocalization: "Validate_Pattern_Product_Category" },
    { value: 51, name: "Product Sub-Category: Not supported Characters \ / ! + < > ? # & , %", keyLocalization: "Validate_Pattern_Product_SubCategory" },
    { value: 52, name: "Variation type name: Not supported Characters \ / ! + < > ? # & , %", keyLocalization: "Validate_Pattern_Variation_Type_Name" },
    { value: 53, name: "Variation Name: Not supported Characters \ / ! + < > ? # & , %", keyLocalization: "Validate_Pattern_Variation_Name" },
    { value: 54, name: "If you selected to add different prices in your item's variations, please enter at least one different.", keyLocalization: "Validate_Different_Variation_Price" },
  ];

  pspef: any = null;
  psnbf: any = null;

  constructor(
    private pointStoreProductEditService: PointStoreProductEditService,
    private pointStoreNavigationBarService: PointStoreNavigationBarService,
      private cvLocalizationService: CVLocalizationService,
      private dialogService: CvDialogService,
    //private jsUtilities: Utilities,
    //private errorDialog: ErrorDialog
  ) {
    this.pspef = pointStoreProductEditService.pointStoreProductEditObj;
    this.psnbf = pointStoreNavigationBarService.data;
  }

  async validateRemoveButton() {
      
      let validation = new window["CVVALIDATION"].ValidationInstance();
    validation.succeeded = false;
    validation.addValidationError(this.pointStoreProductValidationMessages[2].name, true);

      window["showConfirmDialog"]("<ul class='errorBulletList'>" + validation.messagesToListItemsString() + "</ul>",
      [
        {
              text: this.pointStoreProductValidationMessages[0].name,
              click: (e: Event) => {
                  e.stopPropagation();
                  (jQuery(".errorDialog") as any).dialog("close");
                  //return deferred.resolve(true); **** this was not commented
                  return true;
              //Make angular digest! Weeee
              // angular.element('point-store-edit').scope().ctrlPointStoreEdit.applyEditScope(); *** dont know what this is
          }
        },
        {
          text: this.pointStoreProductValidationMessages[1].name,
          click: () => {
            let dialogMsg: any = $(".errorDialog");
            dialogMsg.dialog("close");
            //return deferred.reject(false); **** this was not commented
            return false;
          }
        }
      ], this.pointStoreProductValidationMessages[4].name, "Warning");
  }

    validateCancelButton(byPassValidation = null) {
        return new Promise((resolve, reject) => {
            if (byPassValidation) {
                return resolve(true);
            }

            let validation = new window["CVVALIDATION"].ValidationInstance();
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[3].name, true);

            window["showConfirmDialog"]("<ul class='errorBulletList'>" + validation.messagesToListItemsString() + "</ul>",
                [
                  {
                      text: this.pointStoreProductValidationMessages[0].name,
                      click: () => {
                          let dialogMsg: any = $(".errorDialog");
                          dialogMsg.dialog("close");
                          return resolve(true);
                      }
                 },
                {
                  text: this.pointStoreProductValidationMessages[1].name,
                    click: () => {
                        let dialogMsg: any = $(".errorDialog");
                        dialogMsg.dialog("close");
                        return reject(false);
                  }
                }
                ], this.pointStoreProductValidationMessages[4].name, "Warning");
        });
    }

  validateStepper(validation) {
    if (validation.succeeded == false) {
      if (validation.messagesToListItemsString().length != 0) {
        window["showConfirmDialog"](validation.messagesToListItemsString(),
          [
            {
              text: "Ok",
              click: (e) => {
                let dialogMsg: any = $(".errorDialog");
                e.stopPropagation();
                dialogMsg.dialog("close");
              }
            }
          ], this.pointStoreProductValidationMessages[5].name, "Error");
      }
    }
  }

  /*ListView*/
  async validateDeleteListViewButton() {
    let validation = new window["CVVALIDATION"].ValidationInstance();
    validation.succeeded = false;
    validation.addValidationError(this.pointStoreProductValidationMessages[6].name, true);

    window["showConfirmDialog"]("<ul class='errorBulletList'>" + validation.messagesToListItemsString() + "</ul>",
      [
        {
          text: this.pointStoreProductValidationMessages[0].name,
          click: () => {
            let dialogMsg: any = $(".errorDialog");
            dialogMsg.dialog("close");
            //return deferred.resolve(true); **** comented
            return true;
          }
        },
        {
          text: this.pointStoreProductValidationMessages[1].name,
          click: () => {
            let dialogMsg: any = $(".errorDialog");
            dialogMsg.dialog("close");
            //return deferred.reject(false); **** comented
            return false;
          }
        }
      ], this.pointStoreProductValidationMessages[4].name, "Warning");
  }

  validateEditListViewButton() {
    let validation = new window["CVVALIDATION"].ValidationInstance();
    validation.succeeded = false;
    validation.addValidationError(this.pointStoreProductValidationMessages[7].name, true);

    window["showConfirmDialog"]("<ul class='errorBulletList'>" + validation.messagesToListItemsString() + "</ul>",
      [
        {
          text: this.pointStoreProductValidationMessages[0],
          click: () => {
            let dialogMsg: any = $(".errorDialog");
            dialogMsg.dialog("close");
            //return deferred.resolve(true); *** commented
            return true;
          }
        },
        {
          text: this.pointStoreProductValidationMessages[1],
          click: () => {
            let dialogMsg: any = $(".errorDialog");
            dialogMsg.dialog("close");
            //return deferred.reject(false); *** commented
            return false;
          }
        }
      ], this.pointStoreProductValidationMessages[4], "Warning");
  }

  async validateAssignmentStepper() {
    let validation = new window["CVVALIDATION"].ValidationInstance();
    validation.succeeded = false;
    validation.addValidationError(this.pointStoreProductValidationMessages[8].name);

    window["showConfirmDialog"]("<ul class='errorBulletList'>" + validation.messagesToListItemsString() + "</ul>",
      [
        {
          text: this.pointStoreProductValidationMessages[0].name,
          click: () => {
            let dialogMsg: any = $(".errorDialog");
            dialogMsg.dialog("close");
            //return deferred.resolve(true); *** commented
            return true;
            ////Make angular digest! Weeee
            //angular.element('point-store-edit').scope().ctrlPointStoreEdit.applyEditScope();
          }
        },
        {
          text: this.pointStoreProductValidationMessages[1].name,
          click: () => {
            let dialogMsg: any = $(".errorDialog");
            dialogMsg.dialog("close");
            //return deferred.reject(false); *** commented
            return false;
          }
        }
      ], this.pointStoreProductValidationMessages[4].name, "Warning");
  }

  setNavigationPage(index) {
    //if (this.validatePointStoreProductEditPage(index)) { **************
    const validation= this.validatePointStoreProductEditPage();
    if (validation.succeeded) {
      this.pointStoreNavigationBarService.setSelectedFrame(index);
    }
  }

    async loadMessages() {
        try {
            let response = await this.cvLocalizationService.GetSection("MarketPlace_Management_Messages");
            for (let i = 0; i < this.pointStoreProductValidationMessages.length; i++) {
                this.pointStoreProductValidationMessages[i].name = response.get(this.pointStoreProductValidationMessages[i].keyLocalization)
            }
        } catch (error) {
            showErrorMessage(error.message);
        }
    }

  validatePointStoreProductEditPage() {
    let validation = new window["CVVALIDATION"].ValidationInstance();

    if (this.pspef.modifiedPointStoreProduct == null) {
      validation.addValidationError(this.pointStoreProductValidationMessages[9].name);
    }

    this.validateEditPage(this.psnbf.selectedNavBarSection, validation);
    //pointStoreProductValidationFactory.validateStepper(validation);
    //return validation.succeeded;
    return validation;
  }

  getValidationOfStep(index) {
    let validation = new window["CVVALIDATION"].ValidationInstance();

    if (this.pspef.modifiedPointStoreProduct == null) {
      validation.addValidationError(this.pointStoreProductValidationMessages[9].name);
    }

    this.validateEditPage(index, validation);
    return validation;
  }

  validateEditPage(stepperMenu, validation) {
    switch (stepperMenu) {
      case 0: /*Properties: required to validate*/
        validation.succeeded = true;
      case 1: /*Properties: required to validate*/
        let regex = new RegExp('^([^\\\\\\/!+<>?#&,%])*$');

        validation.test(this.pspef.modifiedPointStoreProduct.Title, {
          TestAs: "String",
          Required: this.pointStoreProductValidationMessages[10].name,
        }); 
        if (!regex.test(this.pspef.modifiedPointStoreProduct.Title)) {
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[48].name);
        }
        //users with descriptions previously saved containing any of the characters described in regex var, will prevent them modify message unless they removed those characters from product description.
        if (!regex.test(this.pspef.modifiedPointStoreProduct.Description)) {
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[49].name);
        }

        validation.test(this.pspef.modifiedPointStoreProduct.Category, {
          TestAs: "String",
          Required: this.pointStoreProductValidationMessages[11].name,
        });
        if (!regex.test(this.pspef.modifiedPointStoreProduct.Category)) {
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[50].name);
        }

        validation.test(this.pspef.modifiedPointStoreProduct.SubCategory, {
          TestAs: "String",
          Required: this.pointStoreProductValidationMessages[12].name,
        });
        if (!regex.test(this.pspef.modifiedPointStoreProduct.SubCategory)) {
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[51].name);
        }

        if (this.pspef.modifiedPointStoreProduct.ProductEnd != null && this.pspef.modifiedPointStoreProduct.ProductEnd.setHours(0, 0, 0, 0) < this.pspef.modifiedPointStoreProduct.ProductStart.setHours(0, 0, 0, 0)) {
          validation.succeeded = false;
          validation.addValidationError(this.pointStoreProductValidationMessages[44].name);
        }
        //validation.test(pointStoreProductValidationFactory.pspef.modifiedPointStoreProduct.Description, {
        //    TestAs: "String",
        //    Required: "Please select a point store product description.",
        //});
        if (!this.pspef.modifiedPointStoreProduct.HasProductVariations) {
          validation.test(this.pspef.modifiedPointStoreProduct.Price, {
            Required: this.pointStoreProductValidationMessages[13].name,
            MinValue: {
              Minimum: 1,
              Message: this.pointStoreProductValidationMessages[14].name,
            },
            WholeNumberOnly: this.pointStoreProductValidationMessages[15].name
          });
          if (this.pspef.modifiedPointStoreProduct.Quantity != null) {
            if (this.pspef.modifiedPointStoreProduct.Quantity.length != 0) {
              validation.test(this.pspef.modifiedPointStoreProduct.Quantity, {
                WholeNumberOnly: this.pointStoreProductValidationMessages[29].name
              });
            }
          }
        }
        validation.test(this.pspef.modifiedPointStoreProduct.ProductStart, {
          Required: this.pointStoreProductValidationMessages[16].name,
          Format: { Type: "GenericDate", Message: this.pointStoreProductValidationMessages[17].name + CVDateFormat }
        });
        if (this.pspef.modifiedPointStoreProduct.HasProductVariations) {
          
          if (!regex.test(this.pspef.modifiedPointStoreProduct.VariationName)) {
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[52].name);
          }
          this.pspef.modifiedPointStoreProduct.VariationsData.forEach((variation, index, array) => {
            //Validation of each variation quantity
            if ((variation.VariationQuantity != null && !Number.isInteger(Number(variation.VariationQuantity)) || variation.VariationQuantity < 0 || variation.VariationQuantity > 99999)
              && (variation.VariationQuantity != null || variation.VariationQuantity != "")) {
              validation.succeeded = false;
              validation.addValidationError(this.pointStoreProductValidationMessages[29].name);
            }

            //Validation regex for each variation Name.
            if (!regex.test(variation.VariationName)) {
                validation.succeeded = false;
                validation.addValidationError(this.pointStoreProductValidationMessages[53].name);
            }
          });
          validation.test(this.pspef.modifiedPointStoreProduct.VariationName, {
            TestAs: "String",
            Required: this.pointStoreProductValidationMessages[39].name,
          });

          if (!this.pspef.modifiedPointStoreProduct.HasVariationPrices) {
            validation.test(this.pspef.modifiedPointStoreProduct.Price, {
              Required: this.pointStoreProductValidationMessages[13].name,
              MinValue: {
                Minimum: 1,
                Message: this.pointStoreProductValidationMessages[14].name,
              },
              WholeNumberOnly: this.pointStoreProductValidationMessages[15].name
            });
          } else {
            this.pspef.modifiedPointStoreProduct.VariationsData.forEach((currentValue, index, array) => {
              validation.test(currentValue.VariationPrice, {
                Required: this.pointStoreProductValidationMessages[13].name,
                MinValue: {
                  Minimum: 1,
                  Message: this.pointStoreProductValidationMessages[14].name,
                },
                WholeNumberOnly: this.pointStoreProductValidationMessages[15].name
              });
            });

            const areAllPricesEqual = this.pspef.modifiedPointStoreProduct.VariationsData.every(currentValue => currentValue.VariationPrice == this.pspef.modifiedPointStoreProduct.VariationsData[0].VariationPrice);
            
            if (areAllPricesEqual) {
                validation.succeeded = false;
                validation.addValidationError(this.pointStoreProductValidationMessages[54].name);
            }
          }
          this.pspef.modifiedPointStoreProduct.VariationsData.forEach((element, index) => {
            validation.test(element.VariationName, {
              TestAs: "String",
              Required: this.pointStoreProductValidationMessages[41].name,
            });
          });
          let variationNames = this.pspef.modifiedPointStoreProduct.VariationsData.map((variation) => { return variation.VariationName });
          let isDuplicate = variationNames.some((item, idx) => {
            return variationNames.indexOf(item) != idx
          });

          if (isDuplicate) {
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[40].name);
          }
        }
        break;
      case 2: /*Setting: required to validate*/
        if (this.pspef.settingPointStoreProduct.Carousel) {
          validation.test(this.pspef.modifiedPointStoreProduct.CarouselStart, {
            Required: this.pointStoreProductValidationMessages[18].name,
            Format: { Type: "GenericDate", Message: this.pointStoreProductValidationMessages[19].name + CVDateFormat }
          });
          if (this.pspef.modifiedPointStoreProduct.CarouselEnd != null && this.pspef.modifiedPointStoreProduct.CarouselEnd.setHours(0, 0, 0, 0) < this.pspef.modifiedPointStoreProduct.CarouselStart.setHours(0, 0, 0, 0)) {
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[45].name);
          }
        }
        if (this.pspef.settingPointStoreProduct.FeaturedProduct) {
          validation.test(this.pspef.modifiedPointStoreProduct.FeatureStart, {
            Required: this.pointStoreProductValidationMessages[20].name,
            Format: { Type: "GenericDate", Message: this.pointStoreProductValidationMessages[21].name + CVDateFormat }
          });
          if (this.pspef.modifiedPointStoreProduct.FeatureEnd != null && this.pspef.modifiedPointStoreProduct.FeatureEnd.setHours(0, 0, 0, 0) < this.pspef.modifiedPointStoreProduct.FeatureStart.setHours(0, 0, 0, 0)) {
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[46].name);
          }
        }
        if (this.pspef.settingPointStoreProduct.Sale) {
          validation.test(this.pspef.modifiedPointStoreProduct.SaleStart, {
            Required: this.pointStoreProductValidationMessages[22].name,
            Format: { Type: "GenericDate", Message: this.pointStoreProductValidationMessages[23].name + CVDateFormat }
          });
          validation.test(this.pspef.modifiedPointStoreProduct.Sale, {
            Required: this.pointStoreProductValidationMessages[24].name,
            MinValue: {
              Minimum: 0,
              Message: this.pointStoreProductValidationMessages[25].name
            },
            MaxValue: {
              Maximum: 100,
              Message: this.pointStoreProductValidationMessages[26].name
            }
          });
          if (this.pspef.modifiedPointStoreProduct.SaleEnd != null && this.pspef.modifiedPointStoreProduct.SaleEnd.setHours(0, 0, 0, 0) < this.pspef.modifiedPointStoreProduct.SaleStart.setHours(0, 0, 0, 0)) {
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[47].name);
          }
        }
        break;
      case 3: /*Upload Image: requiered to validate*/
        if (this.pspef.modifiedPointStoreProduct.HasProductVariations) {
          // Check if at least one of the variations has an assigned image.
          // if so, there must be a main image of the product to show it in case any of the other variations do not have an image assigned to it.
          let variationImagesCount = 0;
          this.pspef.modifiedPointStoreProduct.VariationsData.forEach((element, index) => {
            if (element.VariationImageData != undefined && element.VariationImageData != null)
              variationImagesCount++;
          });
          if (variationImagesCount > 0 && variationImagesCount != this.pspef.modifiedPointStoreProduct.VariationsData.length && !this.pspef.modifiedPointStoreProduct.imageString.length) {
            validation.succeeded = false;
            validation.addValidationError(this.pointStoreProductValidationMessages[42].name);
            validation.skip = true;
          }
        }
        break;
      case 4: /*Assignments: isn't required to validate*/
        if (this.pspef.modifiedPointStoreProduct.PointStoreProductAllAssignments.empAssignAll == false && this.pspef.modifiedPointStoreProduct.PointStoreProductAllAssignments.emp.length <= 0) {
          validation.addValidationWarning(this.pointStoreProductValidationMessages[27].name);
        }
        break;
      case 5: /*Summary: required to validate*/
        this.validateEditPage(1, validation);
        this.validateEditPage(2, validation);
        this.validateEditPage(3, validation);
        //pointStoreProductValidationFactory.validateEditPage(4, validation);
        break;
    }
  }

  showValidationErrorDialog(validation) {
    return new Promise((resolve, reject) => {
      let buttons = [];
    let title = this.pointStoreProductValidationMessages[5].name;

    if (validation.status == "warning") {
      title = this.pointStoreProductValidationMessages[4].name;
      buttons = [
        {
          text: this.pointStoreProductValidationMessages[0].name,
          click: () => {
            let dialogMsg: any = $(".errorDialog");
            dialogMsg.dialog("close");
            return resolve("yes"); //***commented
            /* return "yes"; */

            ////Make angular digest! Weeee
            //angular.element('point-store-edit').scope().ctrlPointStoreEdit.applyEditScope();
          }
        },
        {
          text: this.pointStoreProductValidationMessages[1].name,
          click: () => {
            let dialogMsg: any = $(".errorDialog");
            dialogMsg.dialog("close");
            return resolve("no");  //***commented
            /* return "no"; */
          }
        }
      ];
    }
    else if (validation.status == "error") {
      buttons = [
        {
          text: "OK",
          click: () => {
            let dialogMsg: any = $(".errorDialog");
            dialogMsg.dialog("close");
            return resolve("ok"); //***commented
            /* return "ok"; */
          }
        }
      ];
    }

    window["showConfirmDialog"]("<ul class='errorBulletList'>" + validation.messagesToListItemsString() + "</ul>",
      buttons, title, validation.status);

    });
  }

  validateLandingPageNavigation(index) {
    let validation = new window["CVVALIDATION"].ValidationInstance();

    switch (index) {
      case 0: /* LandingPage Add*/
        validation.succeeded = true;
        break;
      case 1: /* LandingPage Edit*/

        if (this.pspef.modifiedPointStoreProduct == null) {
          validation.addValidationError(this.pointStoreProductValidationMessages[9].name);
        }
        break;
    }
    return validation.succeeded;
  }

  validateLandingPageNavigationAdd() {
    if (this.validateLandingPageNavigation(0)) {
      this.pointStoreNavigationBarService.setSelectedFrame(1);
    }
  }

  validateLandingPageNavigationEdit() {
    if (this.validateLandingPageNavigation(1)) {
      this.pointStoreNavigationBarService.setSelectedFrame(1);
    }
  }

  validatePointStoreProductCancelButton() {
      this.validateCancelButton().then(
          (result) => {
              this.pointStoreProductEditService.copyOriginalToModified();
              this.pointStoreNavigationBarService.setSelectedFrame(0); /*LandingPage*/
              this.pointStoreProductEditService.sortPointStoreProductCollection(); //sort products on cancel
              this.pointStoreProductEditService.resetAddEditUploader(); //Reset the uploader to work (only matters if the user selects the same image, but better safe than sorry!)
          }
      ).catch((result) => { return result; });
    }

  /*ListView*/
  async validatePointStoreProductListViewEditPage(position) {
    let validation = new window["CVVALIDATION"].ValidationInstance();

    if (this.pspef.modifiedPointStoreProduct == null) {
      validation.addValidationError("There is an unknown error. We didn’t see this one coming. Continue anyway?");
    }

    this.validateListViewEditPage(position, validation).then(
      (result) => {
        if (validation.succeeded == false) {
          this.showValidationErrorDialog(validation);
          //return deferred.reject(); ***commented
          return false;
        } else {
          //return deferred.resolve(true); ***commented
          return true;
        }
      },
      function error() {
        this.showValidationErrorDialog(validation);
        //return deferred.reject();***commented
        return false;
      }
    );
    //return validation.succeeded;
  }

  async validateListViewEditPage(position, validation) {
    switch (position) {
      case 1: /*Edit*/
        //pointStoreProductEditFactory.setSelectedPointStoreProductFromListView(); // this isn't working properly

        validation.test(this.pspef.modifiedPointStoreProduct.Title, {
          TestAs: "String",
          Required: this.pointStoreProductValidationMessages[10].name,
        });
        validation.test(this.pspef.modifiedPointStoreProduct.Category, {
          TestAs: "String",
          Required: this.pointStoreProductValidationMessages[11].name,
        });
        validation.test(this.pspef.modifiedPointStoreProduct.SubCategory, {
          TestAs: "String",
          Required: this.pointStoreProductValidationMessages[12].name,
        });
        validation.test(this.pspef.modifiedPointStoreProduct.Price, {
          Required: this.pointStoreProductValidationMessages[13].name,
          MinValue: {
            Minimum: 1,
            Message: this.pointStoreProductValidationMessages[14].name,
          },
          WholeNumberOnly: this.pointStoreProductValidationMessages[15].name
        });

        if (this.pspef.modifiedPointStoreProduct.Quantity != null) {
          if (this.pspef.modifiedPointStoreProduct.Quantity.length != 0) {
            validation.test(this.pspef.modifiedPointStoreProduct.Quantity, {
              Required: this.pointStoreProductValidationMessages[28].name,
              MinValue: {
                Minimum: 1,
                Message: this.pointStoreProductValidationMessages[14].name,
              },
              WholeNumberOnly: this.pointStoreProductValidationMessages[29].name
            });
          }
        }

        validation.test(this.pspef.modifiedPointStoreProduct.ProductStart, {
          Required: this.pointStoreProductValidationMessages[16].name,
          Format: { Type: "GenericDate", Message: this.pointStoreProductValidationMessages[17].name + CVDateFormat }
        });

        //deferred.resolve(true); **** commented
        break;
      case 2: /*Copy*/
        this.validateListViewEditPage(1, validation);
        //deferred.resolve(true); **** commented
        return true;
        break;
      case 12: /*Add*/
        this.validateListViewEditPage(1, validation);
        //deferred.resolve(true); **** commented
        return true;
        break;
      case 4: /*Display Options*/

        if (this.pspef.modifiedPointStoreProduct.IsCarouselChecked) {
          validation.test(this.pspef.modifiedPointStoreProduct.CarouselStart, {
            Required: this.pointStoreProductValidationMessages[30].name,
            Format: { Type: "GenericDate", Message: this.pointStoreProductValidationMessages[19].name + CVDateFormat }
          });
        }

        if (this.pspef.modifiedPointStoreProduct.IsFeaturedChecked) {
          validation.test(this.pspef.modifiedPointStoreProduct.FeatureStart, {
            Required: this.pointStoreProductValidationMessages[31].name,
            Format: { Type: "GenericDate", Message: this.pointStoreProductValidationMessages[21].name + CVDateFormat }
          });
        }

        if (this.pspef.modifiedPointStoreProduct.IsOnSaleChecked) {
          validation.test(this.pspef.modifiedPointStoreProduct.SaleStart, {
            Required: this.pointStoreProductValidationMessages[32].name,
            Format: { Type: "GenericDate", Message: this.pointStoreProductValidationMessages[23].name + CVDateFormat }
          });

          validation.test(this.pspef.modifiedPointStoreProduct.Sale, {
            Required: this.pointStoreProductValidationMessages[33].name,
            MinValue: {
              Minimum: 1,
              Message: this.pointStoreProductValidationMessages[34].name,
            },
            MaxValue: {
              Maximum: 100,
              Message: this.pointStoreProductValidationMessages[35].name
            },
            WholeNumberOnly: this.pointStoreProductValidationMessages[36].name
          });
        }
        if (this.pspef.modifiedPointStoreProduct.CarouselEnd != null && this.pspef.modifiedPointStoreProduct.CarouselEnd < this.pspef.modifiedPointStoreProduct.CarouselStart) {
          validation.succeeded = false;
          validation.addValidationError(this.pointStoreProductValidationMessages[45].name);
        }
        if (this.pspef.modifiedPointStoreProduct.FeatureEnd != null && this.pspef.modifiedPointStoreProduct.FeatureEnd < this.pspef.modifiedPointStoreProduct.FeatureStart) {
          validation.succeeded = false;
          validation.addValidationError(this.pointStoreProductValidationMessages[46].name);
        }
        if (this.pspef.modifiedPointStoreProduct.SaleEnd != null && this.pspef.modifiedPointStoreProduct.SaleEnd < this.pspef.modifiedPointStoreProduct.SaleStart) {
          validation.succeeded = false;
          validation.addValidationError(this.pointStoreProductValidationMessages[47].name);
        }

        //deferred.resolve(true);**** commented
        return true;
        break;
      case 5: /*Assignment*/

        if (this.pspef.modifiedPointStoreProduct.PointStoreProductAllAssignments.empAssignAll == false && this.pspef.modifiedPointStoreProduct.PointStoreProductAllAssignments.emp.length <= 0) {
          //this.validateAssignmentStepper(validation).then( // **** commented
          this.validateAssignmentStepper().then(
            (result) => {
              //return deferred.resolve(true); **** commented
              return true;
            },
            () => { // **** this was error
              validation.addValidationError(this.pointStoreProductValidationMessages[37].name);
              //return deferred.reject(); **** commented
              return false;
              //pointStoreProductValidationFactory.validateStepper(validation);
            }
          );
        } else
          //deferred.resolve(true); **** commented
          return true

        break;
      case 6: /*Multi Edit */
        this.validateListViewEditPage(4, validation);

        //deferred.resolve(true); **** commented
        return true
        break;
      case 9: /*Image Detail*/

        if (this.pspef.modifiedPointStoreProduct.ProductImageID != 0) {
          //deferred.resolve(true); **** commented
          return true;
        } else {
          if (this.pspef.modifiedPointStoreProduct.imageString == undefined) {
            validation.addValidationError(this.pointStoreProductValidationMessages[38].name);
            //deferred.reject(); **** commented
            return false;
          } else if (this.pspef.modifiedPointStoreProduct.imageString.length == 0) {
            validation.addValidationError(this.pointStoreProductValidationMessages[38].name);
            //deferred.reject(); **** commented
            return false;
          } else {
            //deferred.resolve(true); **** commented
            return true;
          }
        }
        //deferred.resolve(true);
        return true;
        break;
      case 13: /*Multi-Assignment*/

        //this.validateListViewEditPage(5, validation).then(function success(result) { return deferred.resolve(true); }, function error() { return deferred.reject(); }); *****
        this.validateListViewEditPage(5, validation).then((result) => { return true }, () => { return false });
        break;
      case 14: /* New edit pop-up */
        validation.test(this.pspef.modifiedPointStoreProduct.Category, {
          TestAs: "String",
          Required: this.pointStoreProductValidationMessages[11].name,
        });
        validation.test(this.pspef.modifiedPointStoreProduct.SubCategory, {
          TestAs: "String",
          Required: this.pointStoreProductValidationMessages[12].name,
        });
        validation.test(this.pspef.modifiedPointStoreProduct.ProductStart, {
          Required: this.pointStoreProductValidationMessages[16].name,
          Format: { Type: "GenericDate", Message: this.pointStoreProductValidationMessages[17].name + CVDateFormat }
        });
        if (this.pspef.modifiedPointStoreProduct.ProductEnd != null && this.pspef.modifiedPointStoreProduct.ProductEnd < this.pspef.modifiedPointStoreProduct.ProductStart) {
          validation.succeeded = false;
          validation.addValidationError(this.pointStoreProductValidationMessages[44].name);
        }
        //deferred.resolve(true); **** commented
        return true;
        break;
    }
  }

  validatePendingImageVariations(): boolean {
    if (this.pspef.modifiedPointStoreProduct.HasProductVariations) {
      // Check if at least one of the variations has an assigned image.
      // if so, there must be a main image of the product to show it in case any of the other variations do not have an image assigned to it.
      let variationImagesCount = 0;
      this.pspef.modifiedPointStoreProduct.VariationsData.forEach((variant, index) => {
        if (variant.VariationImageData != undefined && variant.VariationImageData != null){
          variationImagesCount++;
        }
      });
      if (variationImagesCount > 0 && variationImagesCount != this.pspef.modifiedPointStoreProduct.VariationsData.length && !this.currentUploadedImages()) {
        return true;
      }
    }
    return false;
  }

  /**
   * 
   * @returns boolean value if there is at least a main image
   */
  currentUploadedImages(): boolean {
    const uploaded = (this.pspef.modifiedPointStoreProduct?.imageString || []).some(images => images?.source !== undefined);
    return uploaded;
  }
  
  /**
   * method for resetting validation for main images and variations
   */
  resetImageValidations(): void {
    const isValidationEnabledMainImg = this.pspef.modifiedPointStoreProduct?.imageString.some(images => images?.validation);
    if (isValidationEnabledMainImg) {
      const mainImages = this.disableImageValidation(this.pspef.modifiedPointStoreProduct?.imageString, true);
      this.pspef.modifiedPointStoreProduct.imageString = mainImages;
    }

    const isValidationEnabledVarImg = this.pspef.modifiedPointStoreProduct?.VariationsData.some(images => images?.validation);
    if (isValidationEnabledVarImg) {
      const variationImages = this.disableImageValidation(this.pspef.modifiedPointStoreProduct?.VariationsData);
      this.pspef.modifiedPointStoreProduct.VariationsData = variationImages;
    }
  }

  /**
   * method for remove main images that have validation in case of variants set validation to false
   * @param array arrayn with images
   * @param isMain if the array belongs to main images or not
   * @returns arrayn with images
   */
  disableImageValidation(array: any, isMain = false): any[] {
    if (isMain) {
      return array?.filter(images => !images?.validation);
    }
    const images = array?.map((images) => {
      return {
        ...images,
        validation: false,
      }
    });
    return images;
  }

  validatePointStoreProductEditPageCXOne(): PointStoreProductSaveValidation {
    let validation: PointStoreProductSaveValidation = {
      idError: 0,
      message: ''
    }
    /**
     * idError 
     * message
     */

    if (this.pspef.modifiedPointStoreProduct == null) {
      validation.idError = 9;
      validation.message = this.pointStoreProductValidationMessages[9].name;
      return validation;
    }

    this.validateEditPageCXOne(3, validation);
    return validation;
  }

  validateEditPageCXOne(stepperMenu, validation: PointStoreProductSaveValidation) {
    switch (stepperMenu) {
      case 0: /*Properties: required to validate*/
        validation.idError = 0;
      case 1:
        break;
      case 2:
        break;
      case 3:
        const isPending: boolean = this.validatePendingImageVariations();
        if (isPending) {
          validation.idError = 42;
          validation.message = this.pointStoreProductValidationMessages[42].name;
        }
        break;
      case 4:
        break;
      case 5:
        this.validateEditPage(3, validation);
        break;
    }
  }
}
